/*
  tt-select-a-size.js — Tailgate Tikes "Select A Size" buy-button gating for Dawn 15.5

  WHY THIS EXISTS
  On Dawn 13, picking a size re-rendered the section with ?variant=ID, which set
  product.selected_variant in Liquid and un-disabled the gated add-to-cart button.
  Dawn 15.5 re-renders with ?option_values= instead, which never sets
  product.selected_variant — so the Liquid-gated button came back disabled on every
  selection and could never unlock. This script re-implements the unlock in JS.

  HOW IT WORKS
  Subscribes to Dawn's PUB_SUB_EVENTS.variantChange, which product-info.js publishes
  AFTER its own toggleSubmitButton call — so this handler has the final word on the
  button state. Applies to both the main button (ProductSubmitButton-{section}) and
  the sticky mobile bar button ({...}-Sticky). Sold-out variants stay disabled with
  the "Sold out" label, leaving the Notify Me! app's back-in-stock button in charge.
*/
(function () {
  if (window.__ttSelectASizeInit) return;
  window.__ttSelectASizeInit = true;

  function apply(sectionId, variant, fetchedHtml) {
    ['ProductSubmitButton-' + sectionId].forEach(function (id) {
      /* TT 2026-07-13: sticky bar removed; only the main buy button remains.
         querySelectorAll retained (harmless, robust to re-renders). */
      document.querySelectorAll('[id="' + id + '"]').forEach(function (btn) {
      var label = btn.querySelector('span');
      var priceWrap = btn.querySelector('div');

      if (!variant) {
        // Unavailable option combination — mirror Dawn's unavailable state.
        btn.setAttribute('disabled', 'disabled');
        if (label && window.variantStrings) label.textContent = window.variantStrings.unavailable || label.textContent;
        return;
      }

      // Reveal the in-button price (rendered server-side, hidden while gated) and
      // refresh its contents from the re-render so the chosen variant's price shows.
      if (priceWrap) {
        if (fetchedHtml) {
          var fetchedBtn = fetchedHtml.getElementById(id) || fetchedHtml.getElementById('ProductSubmitButton-' + sectionId);
          var fetchedPrice = fetchedBtn && fetchedBtn.querySelector('div');
          if (fetchedPrice) priceWrap.innerHTML = fetchedPrice.innerHTML;
        }
        priceWrap.classList.remove('rsb-hidden');
        priceWrap.classList.add('rsb-flex', 'rsb-items-center', 'rsb-gap-[8px]');
      }

      if (variant.available) {
        btn.removeAttribute('disabled');
        if (label) label.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
      } else {
        btn.setAttribute('disabled', 'disabled');
        if (label) label.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      }
      });
    });
  }

  function ungateInitialState() {
    // Production (Dawn 13) rendered size pills UNCHECKED until the shopper chose one;
    // stock Dawn 15.5 pre-checks the first available size, which contradicts the
    // gated "Select A Size" button. We can't gate this in Liquid on 15.5 (the
    // option_values re-render would wipe the shopper's selection), so on true first
    // paint only — no ?variant= in the URL — we clear the pre-checked state. Any
    // later re-render arrives through product-info with a real selection and is
    // left alone.
    if (/[?&]variant=/.test(window.location.search)) return;
    document.querySelectorAll('button[id^="ProductSubmitButton-"]').forEach(function (btn) {
      var label = btn.querySelector('span');
      if (!btn.hasAttribute('disabled') || !label || label.textContent.trim().indexOf('Select A') !== 0) return;
      var scope = btn.closest('product-info') || btn.closest('section') || document;
      scope.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (input) {
        input.checked = false;
      });
      scope.querySelectorAll('variant-selects select').forEach(function (sel) {
        var placeholder = sel.querySelector('option[value=""]');
        if (placeholder) sel.value = '';
      });
      // Note: the "SIZE - 2T" legend text deliberately stays as rendered — the live
      // site shows the first size name in the legend even before a pill is chosen.
    });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      // pubsub.js/constants.js not ready yet (both are deferred earlier in the doc);
      // retry on DOMContentLoaded as a safety net.
      document.addEventListener('DOMContentLoaded', init, { once: true });
      return;
    }
    ungateInitialState();
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data) return;
      apply(event.data.sectionId, event.data.variant, event.data.html);
    });
  }

  init();
})();
